<div class="c-appcontent">
    <mat-card class="c-appcontent__card">
        <ng-container *ngIf="loaderService.isLoading$ | async">
            <div class="c-loader">            
                <mat-spinner></mat-spinner>
            </div>
        </ng-container>
        <ng-container *ngIf="!(loaderService.isLoading$ | async)">
            <app-header></app-header>
            <router-outlet></router-outlet>
        </ng-container>
    </mat-card>
</div>
